<div class="warning-animation" [style]="height">
    <div id="animation" class="trigger"></div>
    <svg viewBox="0 0 38 38">
        <path d="M 3,34 L 19,3 L 34,34 Z" class="triangle" />
        <path class="line" d="M 18.9,25 L 18.9,14 Z" />
        <path class="dot" d="M 18.9,27 L 18.9,27.5 Z" />
    </svg>
</div>